<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-range-hood`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M19 4a1 1 0 011 1v9h8V5a1 1 0 011-1h2a1 1 0 011 1v9h.602a1 1 0 01.71.295L46 27.06V34a1 1 0 01-1 1H3a1 1 0 01-1-1v-7.987l12.734-11.748a1 1 0 01.678-.265H16V5a1 1 0 011-1h2zm-5 34a1 1 0 00-1-1h-2a1 1 0 00-1 1v5a1 1 0 001 1h2a1 1 0 001-1v-5zm8 0a1 1 0 00-1-1h-2a1 1 0 00-1 1v5a1 1 0 001 1h2a1 1 0 001-1v-5zm7-1a1 1 0 011 1v5a1 1 0 01-1 1h-2a1 1 0 01-1-1v-5a1 1 0 011-1h2zm9 1a1 1 0 00-1-1h-2a1 1 0 00-1 1v5a1 1 0 001 1h2a1 1 0 001-1v-5zM16.584 18h14.77L42 28.71V31H6v-3.235L16.584 18z"/></svg>
</template>
<script>

export default {
  name: 'IconRangeHood',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
